import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { UserX, AlertTriangle } from 'lucide-react';

const ImpersonationBanner = () => {
  const { impersonatedBy, stopImpersonation, user } = useAuth();

  if (!impersonatedBy) return null;

  return (
    <Alert className="border-amber-200 bg-amber-50 rounded-none border-b-2 border-t-0 border-l-0 border-r-0">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-2 text-amber-800">
          <UserX className="h-4 w-4" />
          <span className="font-medium">
            Taklit Modu: {user?.first_name} {user?.last_name} ({user?.email}) olarak görüntüleniyor
          </span>
          <span className="text-xs bg-amber-200 px-2 py-1 rounded">
            Tarafından: {impersonatedBy.name}
          </span>
        </div>
        <Button 
          size="sm" 
          variant="outline"
          className="border-amber-300 text-amber-700 hover:bg-amber-100"
          onClick={stopImpersonation}
        >
          Taklit Modundan Çık
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default ImpersonationBanner;